<template>
  <div :class="`mb-0 gis-form-renderer-page-modal-container--${frpModalContainer}`">
    <FormRenderPage
      v-if="formTypeId"
      :is-open-in-modal="true"
      :force-fetch-form-data="true"
      :form-type-id="formTypeId"
      :extra-data="extraData"
      style="width: min-content"
      @action="onFormAction"
      :z-index-from="zIndex"
      v-model:frpModalContainer="frpModalContainer"
    />
  </div>
</template>

<script>
import FormRenderPage from './FormRenderPage.vue';
import { mapFormDataBySchema, objectVariable } from '@/js/document/document';

export default {
  inject: ['dialogRef'],
  name: 'FormRenderPageModalContainer',
  components: {
    FormRenderPage,
  },
  computed: {
    zIndex() {
      return document.querySelector('.p-dialog-mask')?.style?.zIndex || 3500;
    },
  },
  data() {
    return {
      formTypeId: null,
      extraData: null,
      frpModalContainer: '',
    };
  },
  mounted() {
    this.formTypeId = this.dialogRef?.data?.formTypeId;
    this.extraData = this.dialogRef?.data?.extraData;
  },
  methods: {
    setModalData(variable, data) {
      if (variable === '${data}' || variable === 'data') {
        return data;
      } else if (/^(data|\$\{data)\./.test(variable)) {
        return objectVariable(data.data ? data : { data: data }, variable);
      } else {
        return mapFormDataBySchema(JSON.parse(variable), data);
      }
    },
    onFormAction(action, value, data) {
      if (action === 'save') {
        if (data?.action?.properties?.onEvent === 'save') {
          let postObj = {
            location: data.location,
            properties: data.properties,
            action: data.action.value,
            geometryId: data.geometryId,
            formData: value,
          };
          if (data?.action?.properties?.onBeforeModalEventVariableSchema) {
            postObj = this.setModalData(data.action.properties.onBeforeModalEventVariableSchema, postObj);
          }
          console.log(postObj);
          window.parent.postMessage(JSON.stringify({ postObj }), '*');
        }
      }
      if (['close', 'cancel', 'save'].includes(action)) {
        this.dialogRef.close();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.p-dialog:not(.p-dialog-maximized){
  .gis-form-renderer-page-modal-container {
    &--small {
      width: 600px;
    }

    &--medium {
      width: 1024px;
    }

    &--large {
      min-width: 96vw;
    }
  }
}

.gis-form-renderer-page-modal-container {
  &--small {
    max-width: 100%;
    resize: both;
  }

  &--medium {
    max-width: 100%;
    resize: both;
  }

  &--large {
    max-width: 100%;
    resize: both;
  }
}
</style>
